/**
 * Kiyoh-widget op mobiel: positie syncen met mobile sticky bar (transform)
 * en footer-ruimte dynamisch reserveren.
 *
 * Kiyoh sticky banner uitzetten: zet onderstaande op true (voegt class "hidden" toe).
 * Weer aanzetten: zet op false.
 */
(function () {
  const KIYOH_STICKY_HIDDEN = true;
  const MOBILE_MAX = 767;
  const KIYOH_SELECTOR = '.kiyoh-shop-snippets';
  const KIYOH_BOTTOM_SELECTOR = '.kiyoh-shop-snippets.alignv-bottom';
  const GAP_PX = 16;

  let rafId = null;

  function hideKiyohSticky() {
    document.querySelectorAll(KIYOH_SELECTOR).forEach((el) => {
      el.classList.add('hidden');
    });
    document.documentElement.style.setProperty('--kiyoh-footer-reserved', '0px');
  }

  function scheduleUpdate() {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      updateKiyohLayout();
    });
  }

  function getAtcBarHeight() {
    const value = getComputedStyle(document.documentElement).getPropertyValue('--sticky-atc-bar-height');
    return parseFloat(value) || 0;
  }

  function getStickyBarVisibleHeight() {
    const stickyBar = document.querySelector('mobile-sticky-bar');
    if (!stickyBar || !document.body.classList.contains('mobile-sticky-bar-enabled')) {
      return 0;
    }

    const rect = stickyBar.getBoundingClientRect();
    const visible = Math.min(rect.height, Math.max(0, window.innerHeight - rect.top));
    return visible;
  }

  function updateKiyohLayout() {
    if (KIYOH_STICKY_HIDDEN) {
      hideKiyohSticky();
      return;
    }

    const kiyoh = document.querySelector(KIYOH_BOTTOM_SELECTOR);
    const isMobile = window.innerWidth <= MOBILE_MAX;

    if (!kiyoh) return;

    if (!isMobile) {
      kiyoh.style.removeProperty('bottom');
      kiyoh.style.removeProperty('transition');
      document.documentElement.style.removeProperty('--kiyoh-footer-reserved');
      return;
    }

    const stickyBarHeight = getStickyBarVisibleHeight();
    const bottomOffset = stickyBarHeight + getAtcBarHeight() + GAP_PX;

    kiyoh.style.transition = 'bottom 0.3s ease';
    kiyoh.style.bottom = `${bottomOffset}px`;

    const kiyohHeight = kiyoh.getBoundingClientRect().height;
    const footerReserved = Math.ceil(kiyohHeight + stickyBarHeight + GAP_PX);
    document.documentElement.style.setProperty('--kiyoh-footer-reserved', `${footerReserved}px`);
  }

  function init() {
    if (KIYOH_STICKY_HIDDEN) {
      hideKiyohSticky();

      const observer = new MutationObserver(hideKiyohSticky);
      observer.observe(document.body, { childList: true, subtree: true });

      setTimeout(hideKiyohSticky, 500);
      setTimeout(hideKiyohSticky, 1500);
      return;
    }

    updateKiyohLayout();

    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('scroll', scheduleUpdate, { passive: true });

    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    const stickyBar = document.querySelector('mobile-sticky-bar');
    if (stickyBar && 'ResizeObserver' in window) {
      new ResizeObserver(scheduleUpdate).observe(stickyBar);
    }

    const kiyoh = document.querySelector(KIYOH_BOTTOM_SELECTOR);
    if (kiyoh && 'ResizeObserver' in window) {
      new ResizeObserver(scheduleUpdate).observe(kiyoh);
    }

    // Kiyoh laadt soms later via app-script
    setTimeout(updateKiyohLayout, 500);
    setTimeout(updateKiyohLayout, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
